import React, { Component, Fragment } from "react";
import Slider from "react-slick";
import ScrollToTop from "react-scroll-up";
import { FiChevronUp } from "react-icons/fi";
import { Helmet } from "react-helmet";
import Header from "../component/header/Header";
import PageHelmet from "../component/common/Helmet";
import { withTranslation } from "react-i18next";
import { portfolioSlick2 } from "./script";

const awardItems = [
    {
        src: "/assets/images/contact/reward-1.webp",
        alt: "นาจันทร์สว่างฟาร์มสเตย์ยโสธร ได้รางวัล 5 ดาว STGs STAR",
        link: "https://www.tatstar.org/company/STAR-B00708"
    },
    {
        src: "/assets/images/contact/reward-2.webp",
        alt: "นาจันทร์สว่างฟาร์มสเตย์ยโสธร ได้รางวัล SME Soft Power Star",
        link: "https://www.facebook.com/share/p/1RiWFYZJK9/"
    },
    {
        src: "/assets/images/contact/MSMEAWARD.png",
        alt: "นาจันทร์สว่างฟาร์มสเตย์ยโสธร ได้รางวัล MSME Provincial Champion Award 2025"
    }
];

const activityItems = [
    { src: "/assets/images/portfolio/portfolio-g.webp", alt: "อนุทินชื่นชม นาจันทร์สว่าง", titleKey: null },
    { src: "/assets/images/portfolio/4.webp", alt: "โคตรคูลมาถ่ายทำที่นาจันทร์สว่าง", titleKey: "home.accessory1" },
    { src: "/assets/images/portfolio/18.webp", alt: "ผู้ว่ามาเยือนนาจันทร์สว่าง", titleKey: "home.accessory2" },
    { src: "/assets/images/portfolio/11.webp", alt: "รางวัล SME Soft Power Star", titleKey: "home.accessory3" },
    { src: "/assets/images/portfolio/50.webp", alt: "รางวัล 5 ดาว STGs STAR", titleKey: "home.accessory4" },
    { src: "/assets/images/portfolio/21.webp", alt: "โรงเรียนบ้านดอนมะยาง กม.3", titleKey: "home.accessory5" },
    { src: "/assets/images/portfolio/2.webp", alt: "โรงเรียนบ้านยางเดี่ยวหนองถ่ม", titleKey: "home.accessory6" },
    { src: "/assets/images/portfolio/51.webp", alt: "กองพันทหารราบที่ 2 กรมทหารราบที่ 16", titleKey: "home.accessory7" },
    { src: "/assets/images/portfolio/52.webp", alt: "Yo! Organic Youth Camp", titleKey: "home.accessory8" }
];

const storyItems = [
    {
        titleKey: "home.anuthinTitle",
        descKey: "home.anuthinDesc",
        image: "/assets/images/portfolio/portfolio-g.webp",
        alt: "อนุทินกล่าวชื่นชม นาจันทร์สว่าง"
    },
    {
        titleKey: "home.govVisitTitle",
        descKey: "home.govVisitDesc",
        image: "/assets/images/portfolio/18.webp",
        alt: "ผู้ว่ามาเยือนนาจันทร์สว่าง"
    },
    {
        titleKey: "home.smeTitle",
        descKey: "home.smeDesc",
        image: "/assets/images/portfolio/11.webp",
        alt: "นาจันทร์สว่างรับรางวัล SME"
    },
    {
        titleKey: "home.stgsTitle",
        descKey: "home.stgsDesc",
        image: "/assets/images/portfolio/50.webp",
        alt: "นาจันทร์สว่างรับรางวัล STGs STAR"
    },
    {
        titleKey: "home.kotcoolTitle",
        descKey: "home.kotcoolDesc",
        desc2Key: "home.kotcoolDesc2",
        image: "/assets/images/portfolio/4.webp",
        alt: "โคตรคูลมาถ่ายทำที่นาจันทร์สว่าง"
    }
];

const galleryImages = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12,
    13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24,
    25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36,
    37, 38, 42, 43, 44, 45, 46, 47, 48, 49, 50
];

class Startup extends Component {
    render() {
        const { t } = this.props;
        const structuredData = {
            "@context": "https://schema.org",
            "@type": "TouristAttraction",
            name: t("home.pageTitle"),
            description: t("home.heroLead"),
            url: "https://chansawangfarm.com/",
            image: "https://chansawangfarm.com/assets/images/portfolio/portfolio-g.webp",
            address: {
                "@type": "PostalAddress",
                addressLocality: "Mueang Yasothon",
                addressRegion: "Yasothon",
                postalCode: "35000",
                addressCountry: "TH"
            }
        };

        return (
            <Fragment>
                <PageHelmet
                    pageTitle={t("home.pageTitle")}
                    siteName={t("common.siteName")}
                    description="นาจันทร์สว่าง ฟาร์มสเตย์ยโสธร พื้นที่เรียนรู้เกษตรอินทรีย์ แคมป์ปิ้ง และกิจกรรมชุมชนที่เป็นมิตรต่อสิ่งแวดล้อม"
                    keywords="นาจันทร์สว่าง, ฟาร์มสเตย์ยโสธร, แคมป์ปิ้งยโสธร, เกษตรอินทรีย์, ท่องเที่ยวยั่งยืน, Chansawang Farm"
                />
                <Helmet>
                    <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
                </Helmet>
                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.webp" />

                <main className="home-modern">
                    <section className="home-hero bg_color--1">
                        <div className="container">
                            <div className="row align-items-center row--20">
                                <div className="col-lg-7 col-md-12">
                                    <div className="home-hero-content">
                                        <h1>{t("home.pageTitle")}</h1>
                                        <p className="home-hero-lead">{t("home.heroLead")}</p>
                                        <div className="home-hero-actions">
                                            <a className="btn-default home-cta-primary" href="/about">{t("home.heroCtaAbout")}</a>
                                            <a className="btn-default btn-border home-cta-secondary" href="/contract">{t("home.heroCtaContact")}</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-5 col-md-12">
                                    <div className="home-hero-media">
                                        <img src="/assets/images/portfolio/portfolio-g.webp" alt="นาจันทร์สว่าง ฟาร์มสเตย์ยโสธร" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="home-awards bg_color--1">
                        <div className="container">
                            <div className="row row--20">
                                {awardItems.map((item, index) => (
                                    <div className="col-lg-4 col-md-4 col-sm-12" key={index}>
                                        <div className="home-award-card">
                                            {item.link ? (
                                                <a href={item.link} target="_blank" rel="noopener noreferrer">
                                                    <img src={item.src} alt={item.alt} loading="lazy" />
                                                </a>
                                            ) : (
                                                <img src={item.src} alt={item.alt} loading="lazy" />
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </section>

                    <section className="home-section bg_color--1">
                        <div className="container">
                            <div className="section-title text-center mb--30">
                                <h2 className="title">{t("home.activityPartner")}</h2>
                            </div>
                            <div className="row row--20 home-activity-grid">
                                {activityItems.map((item, index) => (
                                    <div className="col-lg-4 col-md-6 col-sm-12 home-activity-col" key={index}>
                                        <article className="home-feature-card">
                                            <img src={item.src} alt={item.alt} loading="lazy" />
                                            {item.titleKey ? <h3>{t(item.titleKey)}</h3> : null}
                                        </article>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </section>

                    <section className="home-section bg_color--1">
                        <div className="container">
                            <div className="section-title text-center mb--30">
                                <h2 className="title">{t("home.aboutTitle")}</h2>
                            </div>
                            <div className="home-story-list">
                                {storyItems.map((item, index) => (
                                    <article className="home-story-card" key={index}>
                                        <div className="row align-items-center row--20">
                                            <div className={`col-lg-6 col-md-12 ${index % 2 === 1 ? "order-lg-2" : ""}`}>
                                                <div className="home-story-image">
                                                    <img src={item.image} alt={item.alt} loading="lazy" />
                                                </div>
                                            </div>
                                            <div className={`col-lg-6 col-md-12 ${index % 2 === 1 ? "order-lg-1" : ""}`}>
                                                <div className="home-story-content">
                                                    <h3>{t(item.titleKey)}</h3>
                                                    <p style={{ whiteSpace: "pre-line" }}>{t(item.descKey)}</p>
                                                    {item.desc2Key ? <p>{t(item.desc2Key)}</p> : null}
                                                </div>
                                            </div>
                                        </div>
                                    </article>
                                ))}
                            </div>
                        </div>
                    </section>

                    <section className="home-section home-cta-section bg_color--1">
                        <div className="container">
                            <div className="home-cta-card">
                                <h2>{t("home.ctaSectionTitle")}</h2>
                                <p>{t("home.ctaSectionDesc")}</p>
                                <div className="home-hero-actions">
                                    <a className="btn-default home-cta-primary" href="/education">{t("home.ctaPrimary")}</a>
                                    <a className="btn-default btn-border home-cta-secondary" href="/contract">{t("home.ctaSecondary")}</a>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="home-section bg_color--1" id="portfolio">
                        <div className="container">
                            <div className="section-title text-center mb--30">
                                <h2 className="title">{t("home.thankPartner")}</h2>
                            </div>
                        </div>
                        <div className="wrapper sacousel-inner mb--55">
                            <div className="slick-activation mt--30 mt_sm--30">
                                <Slider {...portfolioSlick2}>
                                    {galleryImages.map((imageNumber) => (
                                        <div className="im_portfolio" key={imageNumber}>
                                            <div className="thumbnail_inner">
                                                <div className="thumbnail">
                                                    <img
                                                        src={`/assets/images/portfolio/${imageNumber}.webp`}
                                                        alt={`กิจกรรมที่นาจันทร์สว่าง ${imageNumber}`}
                                                        loading="lazy"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                            </div>
                        </div>
                    </section>
                </main>
                <div className="home-mobile-sticky-cta">
                    <a href="/education">{t("home.stickyCtaAbout")}</a>
                    <a href="/contract">{t("home.stickyCtaContact")}</a>
                </div>

                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
            </Fragment>
        );
    }
}

export default withTranslation()(Startup);
